module.exports = __webpack_public_path__ + "img/more.d62aaa47.webp";